<header class="tw-relative tw-flex tw-w-full tw-items-center tw-bg-background-alt tw-px-5">
  @if (!hideLogo()) {
    <a
      [routerLink]="['/']"
      class="tw-mx-auto tw-block tw-w-32 tw-py-5 [&>*]:tw-align-top"
    >
      <bit-svg [content]="logo" [ariaLabel]="'appLogoLabel' | i18n"></bit-svg>
    </a>
  }
  <div class="tw-absolute tw-end-5 tw-top-1/2 -tw-translate-y-1/2 [&:has(*)]:tw-py-5">
    <ng-content></ng-content>
  </div>
</header>
